import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "text-base font-bold" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_FilterTable = _resolveComponent("FilterTable")!
  const _component_list = _resolveComponent("list")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, { onActionCreate: _ctx.create }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_PageTitle, { title: "Agency Category Catalog" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "flex mt-3 item-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FilterTable, { onOnFilterCallback: _ctx.onFilterCallback }, null, 8, ["onOnFilterCallback"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_list, {
                onUpdate: _ctx.update,
                onDel: _ctx.del,
                documents: _ctx.documents,
                isLoading: _ctx.isLoading
              }, null, 8, ["onUpdate", "onDel", "documents", "isLoading"]),
              _createVNode(_component_pagination, {
                total: _ctx.total,
                pagination: _ctx.params.page,
                "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.page) = $event)),
                limit: _ctx.params.limit,
                "onUpdate:limit": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.limit) = $event))
              }, null, 8, ["total", "pagination", "limit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialog) = $event)),
        width: "40%",
        onClose: _ctx.cancel
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.type === 'create' ? `Create Category` : `Update Category`), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.addCategory
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            rules: _ctx.rules,
            "label-width": "60px",
            ref: "categoryCatalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Name",
                prop: "title",
                class: "font-bold"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Parent",
                prop: "parentId",
                class: "font-bold",
                hidden: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.parent,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.parent) = $event)),
                    placeholder: "Please select a parent",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item._id,
                          label: item.title,
                          value: item._id,
                          size: 25
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Status",
                class: "font-bold",
                prop: "status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: true, title: 'Active' },
                { value: false, title: 'Inactive' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.title,
                          value: item.value,
                          size: 25
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Type",
                class: "font-bold",
                prop: "type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.type) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: 'pod', title: 'pod' },
                { value: 'fake', title: 'fake' },
                { value: 'drop', title: 'drop' },
              ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.title,
                          value: item.value,
                          size: 25
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Ref",
                class: "font-bold",
                prop: "ref"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.form.ref,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.ref) = $event)),
                    "controls-position": "right",
                    min: 0,
                    max: 50,
                    step: 0.05
                  }, null, 8, ["modelValue", "step"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogDel,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogDel) = $event)),
        title: "Confirm",
        width: "40%"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
              default: _withCtx(() => [
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.confirmDelete
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _hoisted_7,
            _createElementVNode("strong", null, _toDisplayString(_ctx.form.title), 1),
            _hoisted_8
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16, ["onActionCreate"]))
}